// extracted by mini-css-extract-plugin
export default {"formLabel":"form-label_formLabel__1NTx+","error":"form-label_error__bksdn","disabled":"form-label_disabled__-L8ib"};